import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';

import { PopoverMenuItem } from './PopoverMenuItem';

const Background = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export type MenuItemType = {
  title: string;
  href: string;
  submenuItems?: MenuItemType[];
};

export interface DesktopMenuProps {
  menuItems: MenuItemType[];
}

export function DesktopMenu(props: DesktopMenuProps) {
  const { menuItems } = props;

  return (
    <Background>
      <Container component="nav" role="navigation">
        {menuItems.map((menuItem) => (
          <PopoverMenuItem
            key={menuItem.title}
            title={menuItem.title}
            href={menuItem.href}
            submenuItems={menuItem.submenuItems}
          />
        ))}
      </Container>
    </Background>
  );
}
